import store from "@/store";
import { useWindowSize } from "@vueuse/core";
import {
  swalErrorIcon,
  swalInfoIcon,
  swalSuccessIcon,
  swalWarningIcon,
} from "@/icons/statusIcons";
import businessImage from "@/assets/images/icons/dashboard-ceo/logo-business.svg";
import boostCreditImage from "@/assets/images/icons/dashboard-ceo/logo-boost-credit.svg";
import creditExpertsImage from "@/assets/images/icons/dashboard-ceo/logo-credit-experts.svg";
import debtSolutionImage from "@/assets/images/icons/dashboard-ceo/logo-debt-solution.svg";
import taxResearchImage from "@/assets/images/icons/dashboard-ceo/logo-tax-research.svg";
import specialistImage from "@/assets/images/icons/dashboard-ceo/logo-specialist.svg";
import keybookImage from "@/assets/images/icons/dashboard-ceo/logo-keybook.svg";
import crmImage from "@/assets/images/icons/dashboard-ceo/crm-logo.svg";
import paragonImage from "@/assets/images/icons/dashboard-ceo/paragon.png";

export default {
  computed: {
    screenWidth() {
      const { width } = useWindowSize();
      return width.value;
    },

    screenHeight() {
      const { height } = useWindowSize();
      return height;
    },
    isDarkSkin() {
      return store.getters["appConfig/skin"] === "dark";
    },
    isLightSkin() {
      return store.getters["appConfig/skin"] === "light";
    },
  },
  methods: {
    showSuccessSwal(
      title = "Success!",
      text = "Successful Process",
      html = ""
    ) {
      return this.$swal({
        title,
        text,
        imageUrl: swalSuccessIcon,
        imageWidth: 70,
        html,
        confirmButtonText: "Ok",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    showInfoSwal(text = "Important Information", title = "Very Important!") {
      this.$swal({
        title,
        text,
        imageUrl: swalInfoIcon,
        imageWidth: 70,
        confirmButtonText: "Ok",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    showQuestionSwal(
      title = "Do you want to perform this action?",
      text = "You won't be able to revert this!",
      confirm_button = "Yes",
      cancel_button = "No",
      icon = "question",
      config = {}
    ) {
      return this.$swal({
        title,
        text,
        icon: icon,
        showCancelButton: true,
        buttonsStyling: false,
        confirmButtonText: confirm_button,
        cancelButtonText: cancel_button,
        customClass: {
          confirmButton: "btn btn-outline-primary mr-1",
          cancelButton: "btn btn-outline-danger  ",
        },
        ...config,
      });
    },
    showWarningSwal(
      title = "Very Important!",
      text = "Important Information",
      html = ""
    ) {
      this.$swal({
        title,
        text,
        imageUrl: swalWarningIcon,
        imageWidth: 70,
        html,
        confirmButtonText: "Ok",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    showErrorSwal(
      error,
      title = "Sorry, there was an error... try again or contact support !!!",
      icon = "error"
    ) {
      this.$swal({
        html: `<h4><b>${title}</b></h4> <br/> <span class="font-small-3 text-danger">${error}</span>`,
        imageUrl: icon === "warning" ? swalWarningIcon : swalErrorIcon,
        imageWidth: 70,
        confirmButtonText: "Ok",
        customClass: {
          confirmButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
    },
    addPreloader() {
      store.commit("app/SET_LOADING", true);
    },
    removePreloader() {
      store.commit("app/SET_LOADING", false);
    },
    getProgramImageRoute(programId) {
      switch (programId) {
        case 0:
          return crmImage;
        case 1:
          return businessImage;
        case 2:
          return boostCreditImage;
        case 3:
          return creditExpertsImage;
        case 4:
          return debtSolutionImage;
        case 5:
          return taxResearchImage;
        case 7:
          return specialistImage;
        case 8:
          return keybookImage;
        case 9:
          return paragonImage;
        default:
          return crmImage;
      }
    },
  },
};
